module.exports = "<div> <relate-fieldtype :suggestions-prop=suggestions :data.sync=columns :config={}></relate-fieldtype> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/statamic/resources/js/components/formset-builder/columns.template.html
// module id = 355
// module chunks = 0